import React, { ReactElement } from 'react';

import { Logo } from '../Logo/Logo';

import { DepthIllustration } from './assets/DepthIllustration';
import waveOverlay from './assets/waveOverlay.png';

interface IProps {
  logo?: boolean;
  hideLogoOnLargeScreen?: boolean;
  greyWaveOverlayComponent?: ReactElement;
  children: React.ReactNode;
}

export const DepthWaveWrapper = ({ logo, children, greyWaveOverlayComponent }: IProps) => {
  return (
    <div className="grid-col-1 grid h-screen min-h-screen grid-rows-1">
      <div className="col-start-1 row-start-1 flex h-auto w-full flex-col items-center justify-between justify-self-center overflow-y-auto">
        <div className="sm:max-w-onboardingFlow">
          {logo && (
            <div className="flex justify-center px-12 pb-10 pt-12">
              <Logo fullLogo fullLogoHeight={31} fullLogoWidth={160} />
            </div>
          )}
          {children}
        </div>
      </div>
      <DepthIllustration
        orientation="topLeft"
        className="w-col-3 pointer-events-none col-start-1 row-start-1 hidden self-start justify-self-start md:flex"
      />
      <DepthIllustration
        orientation="bottomRight"
        className="w-col-3 pointer-events-none col-start-1 row-start-1 hidden self-end justify-self-end md:flex"
      />
      {greyWaveOverlayComponent && (
        <div className="relative col-start-1 row-start-1 flex w-full flex-col items-center self-end md:hidden">
          <div
            className="h-4 w-full bg-cover sm:h-8"
            style={{ backgroundImage: `url(${waveOverlay.src})` }}
          />
          <div className="flex size-full items-start bg-lake-fog">{greyWaveOverlayComponent}</div>
        </div>
      )}
    </div>
  );
};
